import React from "react";
import DownloadIcon from "@mui/icons-material/Download";
import { initialsOf } from "./profileModel";

export default function ProfileHeader({ name, memberId, roles, onDownload }) {
  const [primaryRole, ...otherRoles] = roles;
  return (
    <div className="pf-hd" data-testid="profile-header">
      <span className="pf-av" aria-hidden="true">
        {initialsOf(name)}
      </span>
      <div>
        <h1>{name}</h1>
        <div className="pf-mt">
          <span className="pf-mono">ID {memberId}</span>
          {primaryRole && <span className="pf-tag dk">{primaryRole}</span>}
          {otherRoles.map((r) => (
            <span key={r} className="pf-tag">{r}</span>
          ))}
        </div>
      </div>
      <div className="pf-acts">
        <button type="button" className="pf-btn pf-btn-o" onClick={onDownload}>
          <DownloadIcon sx={{ fontSize: 14 }} />
          Download profile
        </button>
      </div>
    </div>
  );
}
